module.exports = __webpack_public_path__ + "img/1560807272.9b00556d.jpg";